import { action, computed, observable } from 'mobx';
import { IBopisData } from '../../api/IDataMappings';
import Bopis from '../../domain/entities/Bopis/Bopis';
import Config from '../../domain/entities/Config/Config';
import GenericFormStore, { IBaseFormAttributes, IFormStoreOptions } from '../../domain/entities/AddressFormStore/GenericFormStore';

export interface IBopisFormValues extends IBaseFormAttributes {
  country_id?: number;
  phone: string;
  email: string;
  last_name: string;
  first_name: string;
}

export default class BopisFormData {
  @observable purchaserFormStore: GenericFormStore<IBopisFormValues>;

  @observable proxyFormStore: GenericFormStore<IBopisFormValues>;

  @observable isPurchaserPicking = true;

  @observable doorId: string;

  @observable countryId: number;

  @observable isReady = false;

  @observable config: Config;

  constructor(config: Config) {
    const formStoreOptions: IFormStoreOptions<IBopisFormValues> = {
      initialValues: {
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
      },
    };
    this.config = config;
    this.purchaserFormStore = new GenericFormStore(config, formStoreOptions);
    this.proxyFormStore = new GenericFormStore(config, formStoreOptions);
  }

  @action
  init(values: Bopis): void {
    if (values) {
      const { purchaserPickupInfo, proxyPickupInfo, doorId } = values;
      this.doorId = doorId;
      this.purchaserFormStore.setValues({
        ...purchaserPickupInfo,
        country_id: this.countryId,
        first_name: purchaserPickupInfo?.firstName || this.values.purchaserFirstName,
        last_name: purchaserPickupInfo?.lastName || this.values.purchaserLastName,
      });
      this.proxyFormStore.setValues({
        ...proxyPickupInfo,
        country_id: this.countryId,
        first_name: proxyPickupInfo?.firstName || this.values.proxyFirstName,
        last_name: proxyPickupInfo?.lastName || this.values.proxyLastName,
      });

      if (values.proxyPickupInfo && values.proxyPickupInfo.email.length) {
        this.isPurchaserPicking = false;
      }
    }
  }

  get values(): IBopisData {
    const { values: purchaserFormValues } = this.purchaserFormStore;
    let data: IBopisData;
    data = {
      doorId: this.doorId,
      proxyMode: false,
      purchaserEmail: purchaserFormValues.email,
      purchaserFirstName: purchaserFormValues.first_name,
      purchaserLastName: purchaserFormValues.last_name,
      purchaserPhone: purchaserFormValues.phone,
    };

    if (!this.isPurchaserPicking) {
      const { values: proxyFormValues } = this.proxyFormStore;
      data = {
        ...data,
        proxyEmail: proxyFormValues.email,
        proxyFirstName: proxyFormValues.first_name,
        proxyLastName: proxyFormValues.last_name,
        proxyMode: true,
        proxyPhone: proxyFormValues.phone,
      };
    }

    return data;
  }

  @computed
  get isValid(): boolean {
    return this.isReady
      && this.purchaserFormStore.isValid
      && (this.isPurchaserPicking || this.proxyFormStore.isValid);
  }
}
